import type { FilterRule } from './filterRuleTypes';

export function isRuleEmpty(rule: FilterRule): boolean {
  switch (rule.type) {
    case 'text': {
      const criteriaEmpty = rule.op === 'none' || (rule.op === 'contains' && rule.value === '');
      const valuesEmpty = rule.selectedValues.length === 0;
      return criteriaEmpty && valuesEmpty;
    }
    case 'select':
      return rule.values.length === 0;
    case 'multiPerson': {
      const criteriaEmpty = rule.op === 'none' || (rule.op === 'contains' && rule.value === '');
      const valuesEmpty = rule.names.length === 0;
      return criteriaEmpty && valuesEmpty;
    }
    case 'date':
      return rule.op === 'none' || (rule.op !== 'isEmpty' && rule.op !== 'isNotEmpty' && rule.value === '');
    case 'number':
      return rule.op === 'none';
    case 'boolean':
      return rule.value === null;
    case 'readerTagsFacet': {
      const facets = rule.facets;
      const ids = Object.values(facets);
      return ids.length === 0 || ids.every((arr) => !Array.isArray(arr) || arr.length === 0);
    }
    default:
      return true;
  }
}
